<div style="height: 100%; display: flex; flex: 1; flex-direction: column">
	<div [class.hideNavBar]="hideNavBar" class="page-nav">
		<div (click)="navigatePage(0)" class="btn"><<</div>
		<div (click)="navigatePage(activePage - 1)" class="btn"><</div>
		<div>{{ activePage + 1 }} / {{ pageData.size }}</div>
		<div (click)="navigatePage(activePage + 1)" class="btn">></div>
		<div (click)="navigatePage(pageData.size - 1)" class="btn">>></div>
	</div>
	<div style="overflow: auto">
		<div>
			<ng-container #vc></ng-container>
		</div>
	</div>
</div>
